import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import apiFetch from '@wordpress/api-fetch'
import SliderComponent from "./SliderComponent";

export default class Home {
    constructor() {
        $(document).on('click', '.seo__link', function (e) {
            $(this).hide()
            $('.seo__content_more').slideToggle()
        })

        if (!IRISCollectionCustomer.ecoModeActive) {
            this.strateEvents()
            this.strateSocial()
        }
    }

    async strateEvents() {
        const tempsFortsSlider = await Swiper.create('#strate--temps-forts__list', {
            slidesPerView: '1',
            spaceBetween: 10,
            loop: true,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
            },
            breakpoints: {
                650: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                1200: {
                    slidesPerView: 1.2,
                    spaceBetween: 30,
                },
                1450: {
                    slidesPerView: 1.2,
                    spaceBetween: 40,
                },
            }
        })
    }

    strateSocial() {
        if ($('[data-id="social-wall"]').length > 0) {
            apiFetch({
                path: IRISCollectionCustomer.irisSsoInstagramPath,
                method: 'post',
                data: {limit: 10},
            })
                .then((result) => {
                    $('[data-id="social-wall"]').html(result.render).addClass('is-loaded')
                    import(
                        '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                        ).then(({HcLazyload}) => {
                        HcLazyload.update()
                    })
                })
                .catch((e) => {
                    console.log('Une erreur est survenue pendant le chargement du mur instagram...')
                    window.Sentry.captureMessage('Instagram API fetch error', {
                        level: 'error',
                        tags: {context: 'Instagram', type: 'API Fetch'},
                        exception: e,
                    })
                })
        }
    }
}
